import styled from 'styled-components';

// Dönem sekmelerinin bilgi şeridi (katılımcılar + kapsam farkları aynı görünümü paylaşır).
const PeriodNotice = styled.div`
  margin: 12px 0;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.auxiliar.warning};
`;

export const LIVE_PERIOD_STATUSES = ['active', 'evaluation', 'calibration', 'pending_close'];

// Hangi uyarının gösterileceği: taslakta katılımcı henüz yok; kapanmış/iptal dönem hiç
// doğrulanmaz (spec 2026-10-05 §15/3) ve salt okunurdur; devam eden doğrulanmamış dönem
// eski kapsam yolundadır.
export function periodNoticeKey(period) {
  if (!period) return null;
  if (period.status === 'draft') return 'performance.period.participants.draftNotice';
  if (!LIVE_PERIOD_STATUSES.includes(period.status)) return 'performance.period.participants.closedReadOnly';
  if (!period.participantScopeVerifiedAt) return 'performance.period.participants.notVerified';
  return null;
}

export default PeriodNotice;
